import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnavailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 118,
	height: 118,
	viewBox: "0 0 118 118",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 114,
			height: 114,
			fill: "#FEFEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.8009 78.7999L66.6009 66.6L61.2209 61.22L45.0009 45L42.1809 42.18L39.2009 39.2L36.3809 42.02L41.0009 46.66V73C41.0009 75.2 42.8009 77 45.0009 77H71.3409L75.9609 81.6199L78.8009 78.7999ZM45.0009 73V50.66L58.6809 64.34L57.0009 66.44L53.0009 61L47.0009 69H63.3409L67.3409 73H45.0009ZM50.6609 45L46.6609 41H73.0009C75.2009 41 77.0009 42.8 77.0009 45V71.34L73.0009 67.34V45H50.6609Z",
			fill: "#B0B0D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 114,
			height: 114,
			stroke: "#FEFEFE",
			strokeWidth: 4
		})
	]
});
export default SvgUnavailable;
